module.exports = __webpack_public_path__ + "media/images/sprangrulla-bcd1b86b71c05d405aef16420a4d8c44.gif";